export const DEFAULT_LANGUAGE = "ar";